module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-1-Social-Static-Ad.b09f8533.webp";